module.exports = __webpack_public_path__ + "img/phone.a8f7f8cd.svg";